import { getAppwriteStorageDownloadUrl } from '../../utils/helpers';

export interface ParsedNotificationAction {
  name: string;
  params: string[];
}

export const parseNotificationAction = (action: string): ParsedNotificationAction | null => {
  const trimmedAction = action.trim();
  if (!trimmedAction) {
    return null;
  }

  const [name, ...params] = trimmedAction.split('::').map((token) => token.trim());
  if (!name) {
    return null;
  }

  return { name, params };
};

const actionStub = (actionId?: string, campaignId?: string, leadId?: string) => {
  console.info('Notification action stub: action', { actionId, campaignId, leadId });
};

const lead_status = (leadId?: string, status?: string) => {
  if (!leadId || !status) {
    console.warn('Notification action lead_status received invalid parameters', { leadId, status });
    return;
  }

  console.info('Notification action stub: lead_status', { leadId, status });
};

const campaign_status = (campaignId?: string, status?: string) => {
  if (!campaignId || !status) {
    console.warn('Notification action campaign_status received invalid parameters', { campaignId, status });
    return;
  }

  window.dispatchEvent(new CustomEvent('campaign:status-changed', {
    detail: { campaignId, status },
  }));
};

const download_zip = (bucketId?: string, fileId?: string) => {
  if (!bucketId || !fileId) {
    console.warn('Notification action download_zip received invalid parameters', { bucketId, fileId });
    return;
  }

  const url = getAppwriteStorageDownloadUrl(bucketId, fileId);
  window.open(url, '_blank', 'noopener,noreferrer');
};

const handleUnknownAction = (name: string, params: string[]) => {
  console.warn('Unknown notification action stub:', { name, params });
};

export const dispatchNotificationAction = (action?: string | null) => {
  if (!action) {
    return;
  }

  const parsed = parseNotificationAction(action);
  if (!parsed) {
    console.warn('Unable to parse notification action:', action);
    return;
  }

  switch (parsed.name) {
    case 'action':
      actionStub(parsed.params[0], parsed.params[1], parsed.params[2]);
      break;
    case 'lead_status':
      lead_status(parsed.params[0], parsed.params[1]);
      break;
    case 'download_zip':
      download_zip(parsed.params[0], parsed.params[1]);
      break;
    case 'campaign_status':
      campaign_status(parsed.params[0], parsed.params[1]);
      break;
    default:
      handleUnknownAction(parsed.name, parsed.params);
  }
};
